import { render, staticRenderFns } from "./ModalPhotosSelector.vue?vue&type=template&id=2b596a4c&scoped=true&"
import script from "./ModalPhotosSelector.vue?vue&type=script&lang=js&"
export * from "./ModalPhotosSelector.vue?vue&type=script&lang=js&"
import style0 from "./ModalPhotosSelector.vue?vue&type=style&index=0&id=2b596a4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b596a4c",
  null
  
)

export default component.exports